export default __webpack_public_path__ + "static/media/caro4.106ccec1.jpg";